import { usePost } from "../../api";

export function useCancelSubscriptionBooking() {
  const post = usePost();

  return async (partnerId: string, bookingId: string) => {
    await post(
      `/api/v3/portal/partners/${partnerId}/bookings/${bookingId}/cancel`
    );
  };
}
